<template>
  <v-form 
    @submit.prevent>
    <v-row
      class="mt-0"
    >
      <v-col
        cols="12"
        md="8"
        lg="9"
      >
        <v-card
          flat
          class="mx-3 px-6 pb-16 mb-6"
        >
       
          <v-card-title class="primary--text px-0">Algemeen</v-card-title>
          <v-divider class="primary"></v-divider>

          <v-row
            class="mt-6"
          >
            <v-col
              cols="6"
              lg="4"
            >
              <images-field
                v-model="offerLineProduct.photo_url"
                label="Foto"
                :disabled="!isEditable"
              ></images-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-text-field
                v-model="offerLine.quantity"
                outlined
                label="Aantal"
                class="centered-input"
                readonly
                @change="updateField('quantity')"
                :disabled="!isEditable"
              >
                <template v-slot:prepend-inner>
                  <v-btn
                    small
                    icon
                    @click="offerLine.quantity > 0 ? offerLine.quantity-- : offerLine.quantity"
                    :disabled="!isEditable"
                  ><v-icon small>fas fa-minus</v-icon></v-btn>
                </template>
              
                <template v-slot:append>
                  <v-btn
                    small
                    icon
                    @click="offerLine.quantity++"
                    :disabled="!isEditable"
                  ><v-icon small>fas fa-plus</v-icon></v-btn>
                </template>
              
              </v-text-field>
            </v-col>

          </v-row>

          <v-row
          >
            <v-col
              cols="6"
            >
              <v-text-field
                outlined
                v-model="offerLineProduct.window_description"
                :error-messages="offerLineProductErrors.window_description"
                label="Raamomschrijving"
                @change="updateField('window_description')"
                :disabled="!isEditable"
              ></v-text-field>
            </v-col>

            <v-col
              cols="6"
            >
              <v-text-field
                outlined
                v-model="offerLineProduct.product_features"
                :error-messages="offerLineProductErrors.product_features"
                label="Bijzonderheden"
                @change="updateField('product_features')"
                :disabled="!isEditable"
              ></v-text-field>
            </v-col>


          </v-row>

          <v-card-title class="primary--text px-0">Stofsoort</v-card-title>
          <v-divider class="primary"></v-divider>

          <v-row
            class="mt-6"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                outlined
                v-model="offerLineProduct.fabric_name"
                :error-messages="offerLineProductErrors.fabric_name"
                label="Stofcode en kleurcode"
                @change="updateField('fabric_name')"
                :disabled="!isEditable"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                outlined
                clearable
                v-model="offerLine.supplier_id"
                :error-messages="offerLineErrors.supplier_id"
                :items="suppliers"
                item-value="id"
                item-text="company_name"
                label="Leverancier"
                @change="updateField('supplier_id')"
                :disabled="!isEditable"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-card-title class="primary--text px-0">Maatvoering</v-card-title>
          <v-divider class="primary"></v-divider>

          <v-row
            class="mt-6"
          >

            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.dimensions_width"
                :error-messages="offerLineProductErrors.dimensions_width"
                integer
                label="Breedte"
                suffix="mm"
                @change="updateField('dimensions_width')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.dimensions_clear_width"
                :error-messages="offerLineProductErrors.clear_width"
                integer
                label="Klare breedte"
                suffix="mm"
                @change="updateField('dimensions_clear_width')"
                :disabled="!isEditable"
                :background-color="offerLineProduct.dimensions_clear_width_measured ? 'green' : 'red'"
              >
                <template v-slot:prepend>
                  <simple-checkbox v-model="offerLineProduct.dimensions_clear_width_measured" :true-value="1" :false-value="0" ></simple-checkbox>
                </template>
              </number-field>
            </v-col>

            <v-col
              cols="6"
              sm="3"
            >
              <number-field
                outlined
                v-model="offerLineProduct.dimensions_min_height"
                :error-messages="offerLineProductErrors.dimensions_min_height"
                integer
                persistent-placeholder
                label="Minimale hoogte"
                suffix="mm"
                @change="updateField('dimensions_min_height')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="6"
              sm="3"
            >
              <number-field
                outlined
                v-model="offerLineProduct.dimensions_max_height"
                :error-messages="offerLineProductErrors.dimensions_max_height"
                integer
                persistent-placeholder
                label="Maximale hoogte"
                suffix="mm"
                @change="updateField('dimensions_max_height')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.dimensions_clear_height"
                :error-messages="offerLineProductErrors.clear_height"
                integer
                label="Klare hoogte"
                suffix="mm"
                @change="updateField('dimensions_clear_height')"
                :disabled="!isEditable"
                :background-color="offerLineProduct.dimensions_clear_height_measured ? 'green' : 'red'"
              >
                <template v-slot:prepend>
                  <simple-checkbox v-model="offerLineProduct.dimensions_clear_height_measured" :true-value="1" :false-value="0" ></simple-checkbox>
                </template>
              </number-field>
            </v-col>

          </v-row>


          <v-card-title class="primary--text px-0">Systeem</v-card-title>
          <v-divider class="primary"></v-divider>

          <v-row
            class="mt-6"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                outlined
                clearable
                v-model="offerLineProduct.system_operating_side"
                :error-messages="offerLineProductErrors.system_operating_side"
                :items="convertItems(offerLineType.system_operation_sides)"
                label="Bedieningszijde"
                :return-object="false"
                @change="updateField('system_operating_side')"
                :disabled="!isEditable"
              ></v-combobox>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.system_chain_length"
                :error-messages="offerLineProductErrors.system_chain_length"
                integer
                label="Kettinglengte"
                suffix="mm"
                @change="updateField('system_chain_length')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                outlined
                clearable
                v-model="offerLineProduct.system_id"
                :error-messages="offerLineProductErrors.system_id"
                :items="tierProducts"
                item-value="id"
                item-text="description"
                label="Systeem"
                @change="updateField('system_id')"
                :disabled="!isEditable"
              ></v-select>
            </v-col>
            
            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                outlined
                clearable
                v-model="offerLineProduct.system_unroll"
                :error-messages="offerLineProductErrors.system_unroll"
                :items="convertItems(offerLineType.system_unrolls)"
                label="Afrollen"
                :return-object="false"
                @change="updateField('system_unroll')"
                :disabled="!isEditable"
              ></v-combobox>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                outlined
                clearable
                v-model="offerLineProduct.system_tube"
                :error-messages="offerLineProductErrors.system_tube"
                :items="convertItems(offerLineType.system_tubes)"
                label="Buisdikte"
                :return-object="false"
                @change="updateField('system_tube')"
                :disabled="!isEditable"
              ></v-combobox>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                outlined
                clearable
                v-model="offerLineProduct.system_bottom_frame"
                :error-messages="offerLineProductErrors.system_bottom_frame"
                :items="convertItems(offerLineType.system_bottom_frames)"
                label="Onderlijst"
                :return-object="false"
                @change="updateField('system_bottom_frame')"
                :disabled="!isEditable"
              ></v-combobox>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                outlined
                clearable
                v-model="offerLineProduct.system_chain_color"
                :error-messages="offerLineProductErrors.system_chain_color"
                :items="convertItems(offerLineType.system_chain_colors)"
                label="Kettingkleur"
                :return-object="false"
                @change="updateField('system_chain_color')"
                :disabled="!isEditable"
              ></v-combobox>
            </v-col>


          </v-row>

          <v-card-title class="primary--text px-0">Montage</v-card-title>
          <v-divider class="primary"></v-divider>

          <v-row
            class="mt-6"
          >
            <v-col 
              cols="6"
              sm="3"
            >
              <v-select
                outlined
                clearable
                v-model="offerLineProduct.mounting_type"
                :error-messages="offerLineProductErrors.mounting_type"
                :items="convertItems(offerLineType.mounting_types)"
                label="Montage"
                @change="updateField('mounting_type')"
                :disabled="!isEditable"
              ></v-select>
            </v-col>

            <v-col 
              cols="6"
              sm="3"
            >
              <v-combobox
                outlined
                clearable
                v-model="offerLineProduct.mounting_material"
                :error-messages="offerLineProductErrors.mounting_material"
                :items="convertItems(offerLineType.mounting_materials)"
                label="Materiaal"
                :return-object="false"
                @change="updateField('mounting_material')"
                :disabled="!isEditable"
              ></v-combobox>
            </v-col>


            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.mounting_ceiling_height"
                :error-messages="offerLineProductErrors.mounting_ceiling_height"
                integer
                label="Montagehoogte"
                suffix="mm"
                @change="updateField('mounting_ceiling_height')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.mounting_strain"
                :error-messages="offerLineProductErrors.mounting_strain"
                decimals="2"
                label="Ingespannen"
                prefix="€"
                @change="updateField('mounting_strain')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                outlined
                v-model="offerLineProduct.mounting_strain_description"
                :error-messages="offerLineProductErrors.mounting_strain_description"
                label="Omschrijving"
                @change="updateField('mounting_strain_description')"
                :disabled="!isEditable"
              ></v-text-field>
            </v-col>

          </v-row>


          <v-card-title class="primary--text px-0">Opties</v-card-title>
          <v-divider class="primary"></v-divider>

          <v-row
            class="mt-6"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <button-field
                v-model="offerLineProduct.options_special_assembly"
                :items="[{ value: 1, text: 'JA' }, { value: 0, text: 'NEE' }]"
                label="Speciale montage / gereedschap"
                @change="updateField('options_special_assembly')"
                :disabled="!isEditable"
              ></button-field>
            </v-col>

          </v-row>
          <v-row>

            <v-col
              cols="12"
              lg="6"
            >
              <v-text-field
                outlined
                v-model="offerLineProduct.options_description"
                :error-messages="offerLineProductErrors.options_description"
                label="Optieomschrijving"
                @change="updateField('options_description')"
                :disabled="!isEditable"
              ></v-text-field>
            </v-col>

          </v-row>
          <v-row>

            <v-col
              cols="12"
              lg="6"
            >
              <v-textarea
                outlined
                v-model="offerLineProduct.options_remarks"
                :error-messages="offerLineProductErrors.options_remarks"
                label="Overige opmerkingen"
                @change="updateField('options_remarks')"
                :disabled="!isActive"
              ></v-textarea>
            </v-col>

            <v-col
              cols="12"
              lg="6"
            >
              <v-textarea
                outlined
                v-model="offerLineProduct.studio_remarks"
                :error-messages="offerLineProductErrors.studio_remarks"
                label="Atelier opmerkingen"
                @change="updateField('options_remarks')"
                :disabled="!isActive"
              ></v-textarea>
            </v-col>

          </v-row>

          <v-card-title class="primary--text px-0">Overzicht</v-card-title>
          <v-divider class="primary"></v-divider>


          <v-row
            class="mt-6"
            >

            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLineProduct.additional_price"
                :error-messages="offerLineProductErrors.additional_price"
                label="Meerprijs"
                prefix="€"
                decimals="2"
                @change="updateField('additional_price')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <number-field
                outlined
                v-model="offerLine.unit_price"
                :error-messages="offerLineErrors.unit_price"
                decimals="2"
                label="Prijs"
                prefix="€"
                @change="updateField('unit_price')"
                :disabled="!isEditable"
              ></number-field>
            </v-col>
          </v-row>
          <v-row>

            <v-col
              cols="12"
              sm="6"
            >
              <date-picker
                outlined
                v-model="offerLine.delivery_date"
                :error-messages="offerLineErrors.delivery_date"
                label="Leverweek"
                @change="updateField('delivery_date')"
                :suffix="'week ' + formatDate(offerLine.delivery_date, 'W')"
                :disabled="!isActive"
              ></date-picker>

            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="offerLine.is_long_delivery_time"
                :error-messages="offerLineErrors.is_long_delivery_time"
                label="Lange levertijd"
                :disabled="!isActive"
              ></v-checkbox>

            </v-col>

          </v-row>


        </v-card>

      </v-col>
      <v-col
        cols="12"
        md="4"
        lg="3"
        class="pl-6 pl-md-3"
      >

        <v-banner
          sticky
          class="sticky-card"
        >

        <v-card
          flat
          class="pb-6"
        >
          <v-toolbar
            dark
            class="primary"
            dense
            elevation="0"
          >
            <v-toolbar-title>{{ offerLineType.name }}</v-toolbar-title>
          </v-toolbar>

          <dl class="row my-6 px-6 def-list">

            <dt class="col-6">Leverancier:</dt>
            <dd class="col-6"><template v-if="supplier">{{ supplier.company_name }}</template></dd>
            <dt class="col-6">Systeemkeuze:</dt>
            <dd class="col-6"><template v-if="tierProduct">{{ tierProduct.description }}</template></dd>
            <dt class="col-6">Stofnaam + kleur:</dt>
            <dd class="col-6">{{ offerLineProduct.fabric_name }}</dd>
            <dt class="col-6 pt-3 primary--text">Klare breedte:</dt>
            <dd class="col-6 pt-3 primary--text"><template v-if="offerLineProduct.dimensions_clear_width">
                <span :style="{ color: offerLineProduct.dimensions_clear_width_measured ? 'green' : 'red' }">{{ offerLineProduct.dimensions_clear_width }} mm</span>
              </template></dd>
            <dt class="col-6 pb-3 primary--text">Klare hoogte:</dt>
            <dd class="col-6 pb-3 primary--text"><template v-if="offerLineProduct.dimensions_clear_height">
                <span :style="{ color: offerLineProduct.dimensions_clear_height_measured ? 'green' : 'red' }">{{ offerLineProduct.dimensions_clear_height }} mm</span>
              </template></dd>
            <dt class="col-6">Bedieningszijde:</dt>
            <dd class="col-6">{{ offerLineProduct.system_operating_side }}</dd>
            <dt class="col-6">Kettinglengte:</dt>
            <dd class="col-6"><template v-if="offerLineProduct.system_chain_length">{{ offerLineProduct.system_chain_length }} mm</template></dd>

            <dt class="col-6">Afrollen:</dt>
            <dd class="col-6"><span :class="{ 'error--text': isSystemUnrollContra }">{{ offerLineProduct.system_unroll }}</span></dd>
            <dt class="col-6">Onderlijst:</dt>
            <dd class="col-6">{{ offerLineProduct.system_bottom_frame }}</dd>
            <dt class="col-6">Kettingkleur:</dt>
            <dd class="col-6">{{ offerLineProduct.system_chain_color }}</dd>

            <dt class="col-6 pt-3">Bijzonderheden:</dt>
            <dd class="col-6 pt-3 error--text">{{ offerLineProduct.product_features }}</dd>

            <dt class="col-6 pt-3">Overige opmerkingen:</dt>
            <dd class="col-6 pt-3">{{ offerLineProduct.options_remarks }}</dd>

            <dt class="col-6 pt-3 primary--text">Prijs:</dt>
            <dd class="col-6 pt-3 primary--text">{{ formatCurrency(price) }}</dd>

          </dl>

        </v-card>

        <v-btn
          block
          depressed
          color="primary"
          class="mt-6"
          large
          @click="saveClick"
          v-if="isActive"
        >Opslaan</v-btn>

        <v-btn
          block
          depressed
          color="primary"
          class="mt-6"
          large
          @click="downloadOfferLineDialog = true"
          v-if="isActive"
        >Atelierbon</v-btn>

        <v-btn
          block
          depressed
          color="primary"
          class="mt-6"
          large
          @click="mailStudioDialog = true"
          v-if="isActive"
        >Verstuur naar atelier</v-btn>

        <v-btn
          block
          outlined
          color="primary"
          class="mt-6 white"
          large
          @click="backClick"
        >Terug</v-btn>

        </v-banner>

      </v-col>
    </v-row>

    <v-dialog
      v-model="downloadOfferLineDialog"
      max-width="700"
      persistent
    >
      <v-card>
        <v-toolbar color="title" dark flat short class="px-2">
          <v-toolbar-title>Atelierbon</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="downloadOfferLineDialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text>
        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="downloadOfferLineClick(false)"
          >Openen</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="downloadOfferLineClick(true)"
          >Download</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <mail-studio-dialog
      v-model="mailStudioDialog"
      max-width="700"
      persistent
    ></mail-studio-dialog>

  </v-form>
</template>

<script>
import { ref, inject, computed, getCurrentInstance} from 'vue'
import NumberField from '@/components/NumberField'
import ButtonField from '@/components/ButtonField'
import DatePicker from '@/components/DatePicker'
import ImagesField from '@/components/ImagesField.vue'
import SimpleCheckbox from '@/components/SimpleCheckbox'
import MailStudioDialog from './MailStudioDialog.vue'
import { convertItems, useOffer, useOfferLine, formatCurrency, formatDate } from '@/utils'


export default {
  components: {
    NumberField,
    ButtonField,
    DatePicker,
    ImagesField,
    SimpleCheckbox,
    MailStudioDialog,
  },
  setup(props) {

    const api = inject('api')
    const loader = inject('loader')

    const offerModel = inject('offerModel')
    const offerLineTypeModel = inject('offerLineTypeModel')
    const offerLineModel = inject('offerLineModel')
    const offerLineProductModel = inject('offerLineProductModel')

    const suppliers = inject('suppliers')
    const mailStudioDialog = ref(false)
    const downloadOfferLineDialog = ref(false)

    const { proxy } = getCurrentInstance()

    const { attributes: offerLineType } = offerLineTypeModel
    const { attributes: offerLine, errors: offerLineErrors, oldAttributes: oldOfferLine } = offerLineModel
    const { attributes: offerLineProduct, errors: offerLineProductErrors, oldAttributes: oldOfferLineProduct } = offerLineProductModel
    const { isEditable, isActive } = useOffer(offerModel)
    const { price, isSystemUnrollContra } = useOfferLine(offerLineModel, offerLineProductModel)

    const supplier = computed(() => suppliers.value ? suppliers.value.find(item => item.id == offerLineModel.getAttribute('supplier_id')) : {})

    // systems
    const tierProducts = api.resource('tier-products').collection().all({
      filter: { tier_product_type_id: { eq: 1 }, },
      sort: 'sort_index',
    })

    const tierProduct = computed(() => tierProducts.value ? tierProducts.value.find(item => item.id == offerLineProductModel.getAttribute('system_id')) : {})

    function updateField(field) {
      console.log('update', field, offerLineProductModel.getAttribute(field))

      if (['system_id', 'dimensions_clear_width', 'dimensions_clear_height'].includes(field)) {
        let systemId = offerLineProductModel.getAttribute('system_id')
        let dimensionsClearWidth = Number(offerLineProductModel.getAttribute('dimensions_clear_width', 0))
        let dimensionsClearHeight = Number(offerLineProductModel.getAttribute('dimensions_clear_height', 0))

        if (systemId && dimensionsClearWidth && dimensionsClearHeight) {
          api.resource('tier-products').get(`${systemId}/price/${dimensionsClearWidth}/${dimensionsClearHeight}`).then(response => {
            offerLineProductModel.setAttribute('system_price', response.data)
            updateField('system_price')
          })
        } else {
            offerLineProductModel.setAttribute('system_price', null)
            updateField('system_price')
        }
      }

      // unit price
      if (['system_price', 'mounting_strain', 'additional_price'].includes(field)) {
        let systemPrice = Number(offerLineProductModel.getAttribute('system_price', 0))
        let mountingStrain = Number(offerLineProductModel.getAttribute('mounting_strain', 0))
        let additionalPrice = Number(offerLineProductModel.getAttribute('additional_price', 0))
        let unitPrice = systemPrice + mountingStrain
        offerLineModel.setAttribute('unit_price', unitPrice + additionalPrice)
        updateField('unit_price')
      }

      // description
      if (['window_description', 'product_features', 'fabric_name', 'system_bottom_frame'].includes(field)) {
        // ruimte/product/bijzonderheden/stofcode + kleurcode/onderlijst.
        let description = (offerLineProductModel.getAttribute('window_description') ? offerLineProductModel.getAttribute('window_description') + ', ' : '')
            + 'rolgordijn'
            + (offerLineProductModel.getAttribute('product_features') ? ', ' + offerLineProductModel.getAttribute('product_features') : '')
            + (offerLineProductModel.getAttribute('fabric_name') ? ', ' + offerLineProductModel.getAttribute('fabric_name') : '')
            + (offerLineProductModel.getAttribute('system_bottom_frame') ? ', onderlijst ' + offerLineProductModel.getAttribute('system_bottom_frame').toLowerCase() : '')
        
        offerLineModel.setAttribute('description', description)
        updateField('description')
      }

    }

    function downloadOfferLineClick(download = true) {
      offerLineModel.save().then(({ data: offerLine }) => {
        offerLineProductModel.populate({ offer_line_id: offerLine.id })
        offerLineProductModel.save().then(() => {
          loader.show()
          api.resource('offer-lines').get(`${offerLineModel.getAttribute('id')}/pdf`, {
            responseType: 'blob',
          }).then(({ data }) => {
            const url = window.URL.createObjectURL(data)
            let title = 'Atelierbon'
            if (!download) {
              let w = window.open(url, '_blank')
              let i = setInterval(() => { w.document.title = title }, 100)
              setTimeout(() => { clearInterval(i) }, 5000)
            } else {
              const link = document.createElement('a')
              link.href = url
              link.download = title
              link.click()
            }
            // remove after x seconds
            setTimeout(() => { URL.revokeObjectURL(url) }, 6000)
          }).finally(() => {
            loader.hide()
            downloadOfferLineDialog.value = false
          })
        })
      })
    }

    function saveClick() {
      offerLineModel.save().then(({ data: offerLine }) => {
        offerLineProductModel.populate({ offer_line_id: offerLine.id })
        offerLineProductModel.save().then(() => {
          backClick()
        })
      })
    }

    function backClick() {
      proxy.$router.push({
        name: 'offer',
        params: { id: offerLineModel.getAttribute('offer_id') },
      })
    }

    return {
      isEditable,
      isActive,
      offerLineType,

      offerLine,
      offerLineErrors,
      oldOfferLine,
      offerLineProduct,
      offerLineProductErrors,
      oldOfferLineProduct,
      convertItems,
      formatCurrency,
      formatDate,
      suppliers,
      supplier,
      isSystemUnrollContra,
      saveClick,
      backClick,
      price,
      tierProducts,
      tierProduct,
      updateField,
      mailStudioDialog,
      downloadOfferLineDialog,
      downloadOfferLineClick,
    }
  },
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center
}

::v-deep .sticky-card {
  top: 140px !important;
}

::v-deep .sticky-card > .v-banner__wrapper {
  padding: 0 !important;
}

dl.def-list dt {
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 2px;
}

dl.def-list dd {
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 2px;
}


</style>